var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 49,
    viewBox: "0 0 24 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#usud44708a)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.5,
    cy: 48,
    rx: 10.5,
    ry: 1,
    fill: "#E6E6E6",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.424 37.186c-1.415-9.28-10.083-7.468-8.844-17.2-3.538 7.242 3.36 9.052-.708 15.842-5.167 8.624 3.62 12.069 3.62 12.069.448-.752-3.777-2.606-.493-5.546 3.243-2.904.552-7.353.552-7.353s3.398 3.087 3.398 7.168c0 3.537-3.023 5.692-2.405 5.817.196-.02.419-.057.672-.118.224-.064.502-.152.849-.267 0 0 4.599-3.169 3.36-10.412h-.001z",
    fill: "#FF9800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.846 14.809s-4.252 4.045-3.12 10.531c-3.607-2.639-2.374-8.216-.776-11.466C19.84 5.953 14.02-.49 13.648.03c-.352.492 1.063 2.076.179 4.566-1.442 4.058-6.502 5.662-9.552 13.127-4.068 9.958.885 16.07.885 16.07s-2.3.678-4.304-5.589c-4.364 16 9.256 19.694 11.637 19.694 0 0-8.786-3.445-3.619-12.069 4.069-6.79-2.83-8.6.708-15.843-1.238 9.733 7.429 7.922 8.844 17.201 1.238 7.243-3.36 10.412-3.36 10.412 6.804-2.814 9.478-9.341 8.843-15.843-.884-9.054-6.367-8.148-4.06-16.946h-.003z",
    fill: "#FF4900"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.947 42.166c0-4.081-3.397-7.168-3.397-7.168s2.69 4.452-.552 7.353c-3.283 2.94.942 4.792.491 5.546 0 0 .338.156 1.051.086-.617-.127 2.406-2.282 2.406-5.817h.001z",
    fill: "#FFF2B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "usud44708a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v49H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.56f01c3f3942bcfd0708518ced3c8039.svg";
export { ForwardRef as ReactComponent };